import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const transferToQueueActions = createActions(
  {
    TRANSFER_TO_QUEUE_MODAL_REQUEST: [
      (payload) => payload,
      (_, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],

    TRANSFER_TO_QUEUE_MODAL_REQUEST_SUCCEEDED: (_, meta) => ({ meta }),
    TRANSFER_TO_QUEUE_MODAL_REQUEST_FAILED: (_, meta) => ({ meta }),
  },

  'TRANSFER_TO_QUEUE_MODAL_REQUEST_STOP',

  'TRANSFER_TO_QUEUE_WS_RESPONSE',
  'TRANSFER_TO_QUEUE_WS_TRANSFER_STARTED',
  'TRANSFER_TO_QUEUE_WS_TRANSFER_ANSWERED',
);
